<template>
  <!-- 顶部导航 -->
  <div class="top-bar z-10">
    <h1 class="blk-title">{{ dataHeader.title }}</h1>
    <div class="blk-nowdate">
      <div>{{nowdate}} <span class="pt-15">{{nowtime}}</span></div>
    </div>
  </div>
</template>

<script>
import API from "@/api/sascreen-api.js"

export default {
  name: 'top-bar',
  components: {
  },
  props: ['dataHeader'],
  data() {
    return {
      nowdate: '', //日期
      nowdateweater: '',//天气日期
      nowtime: '', //时间
      newTimer: '', //定时器
      count: "",//倒计时
      weater: ''
    }
  },
  created () {

  },
  mounted () {
    this.timerOneScondRun(); //执行日期函数
    this.viewWeather();
    clearInterval(this.newTimer); //清除定时器
    // 定时获取时间
    this.newTimer = setInterval(this.timerOneScondRun, 1000);

  },
  beforeRouteLeave(to,from,next){
    // 离开组件时停掉定时器，节省内存
    clearInterval(this.newTimer);
    next();
  },
  methods: {
    //跳转连接
    goToLinkyun() {
      let url = redirectPage.redirectYun;
      window.open(url, '_blank')
    },
    goToLinkmodle() {
      let url = redirectPage.redirectModule;
      window.open(url, '_blank')
    },

    //获取时间
    timerOneScondRun() {
      let date = new Date();
      // 日期格式  2023年05月31日
      this.nowdate =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "月" +
        (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + '日';
      // 日期格式  2023-05-31
      this.nowdateweater =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate());

      // 时间格式 12:11:27
      this.nowtime =
        date.getHours() +
        ":" +
        (date.getMinutes() >= 10
          ? date.getMinutes()
          : "0" + date.getMinutes()) +
        ":" +
        (date.getSeconds() >= 10 ? date.getSeconds() : "0" + date.getSeconds());
    },
    //3秒后进入跳转页面
    startDivi() {
      // var url = "https:\\www.baidu.com";
      const TIME_COUNT = 3;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            //跳转的页面写在此处
            window.location.href = url;
          }
        }, 1000)
      }
    },
    viewWeather() {
      const yubaotime = this.nowdateweater + ' 12:00:00'
      API.getWeather({
        yubaotime: yubaotime,
        point: '94.67363823864744,43.24477446723496',
        token: '5b468844b5433edeb959606a4aeea70c'
      }).then(data => {
        if (data.data.data === undefined) {
          const weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
          const now = new Date();
          this.currentWeekDay = weekdays[now.getDay()];
          this.weater = weekdays[now.getDay()];
        } else {
          const daymin = data.data.data['2T_instant'].daymin.toFixed(0)
          const daymax = data.data.data['2T_instant'].daymax.toFixed(0)
          this.weater = '天气：' + data.data.data.calculationPM[0].pm + ' ' + daymin + '°C ~' + daymax + '°C'
        }

      })
    }
  },
}
</script>

<style lang="scss">
.top-bar{
  background: url(/imgs/satwotopbar-bg.png) top / 100% no-repeat;
  height:102px;
  overflow: hidden;
  position: relative;
}
.blk-title{
  font-size: 35px;
  letter-spacing: 5px;
  text-align: left;
  font-weight: 500;
  line-height: 90px;
  width: 100%;
  text-align: center;
  color: #19ECFF;
}
.blk-linklogo{
  float: right;
  margin: 47px 22px;
}
.blk-linklogo img{
  display: inline-block;
  width: 42px;
  height: 42px;
  border-radius: 100px;
  margin-left: 28px;
  cursor: pointer;
}

.blk-nowdate{
  position: absolute;
  top:0;
  right: 0;
  margin-top: 20px;
  margin-right: 35px;
  font-size:18px;
  letter-spacing: 2px;
  color: #fff;
}


</style>
